<template>
  <div class="app">
    <DefaultHeader>
      <HeaderQuickSearch class="d-block"></HeaderQuickSearch>
      <Breadcrumb class="d-md-down-none" :list="list" />
    </DefaultHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader></SidebarHeader>
        <SidebarForm />
        <MySidebarNav :nav-items="navItemsMapped" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main" :class="{'communications-main': isCommsPage}">
          <transition name="fade" mode="out-in">
            <div :class="{'communications-wrapper': isCommsPage, 'container-fluid': !isCommsPage}">
                <router-view />
            </div>
          </transition>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <DefaultFooter> </DefaultFooter>
  </div>
</template>

<script>
import navFile from '@/_nav';
import {
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  Aside as AppAside,
  Breadcrumb
} from '@coreui/vue';
import MySidebarNav from './MySidebarNav';
import DefaultAside from './DefaultAside';
import DefaultHeader from './DefaultHeader';
import DefaultFooter from './DefaultFooter';
import HeaderQuickSearch from './HeaderQuickSearch';

export default {
  name: 'DefaultContainer',
  components: {
    MySidebarNav,
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader,
    HeaderQuickSearch
  },
  data() {
    return {
      nav: []
    };
  },
  computed: {
    navItemsMapped: {
      get() {
        let navInfo = navFile.navItems;
        let navItms = [];
        navInfo.forEach(itm => {
          if(this.checkIfCanSeeNavItem(itm) !== false) {
            this.setNavItemDefaults(itm);
            navItms.push(itm);
          }
        });
        this.nav = navItms;
        return navItms;
      },
      set(val) {
        this.nav = val;
      }
    },
    alertNumbers: {
      get() {
        return this.$store.getters.getAlertNumbers;
      }
    },
    isCommsPage() {
      let isTrue = false;
      if(this.$route && this.$route.name) {
        if(this.$route.name.includes('Communications.')) {
          isTrue = true;
        }
      }
      return isTrue;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  mounted() {
    this.checkIfShouldCollapse();
    window.onresize = event => {
      this.checkIfShouldCollapse();
    };
  },
  methods: {
    setNavItemDefaults(navItm) {
      navItm.isOpen = false;
      if(navItm.url == '/inventory/warehouseTransfers') {
        navItm.badgeUrl = '/inventory/warehouseTransfers?realStatus=Draft';
        navItm.badgeNumber = this.alertNumbers.toReviewWarehouseTransfers;
      }
      else if(navItm.url == '/storefronts/shipcode-mappings') {
        navItm.badgeUrl = '/storefronts/shipcode-mappings?status=PendingApproval';
        navItm.badgeNumber = this.alertNumbers.toReviewShipCodeMappings;
      }
      else if(navItm.url == '/inventory/purchaseOrders') {
        navItm.badgeUrl = '/inventory/purchaseOrders?orderStatus=Draft';
        navItm.badgeNumber = this.alertNumbers.toReviewPurchaseOrders;
      }
      else if(navItm.url == '/manage/clients/items') {
        navItm.badgeUrl = '/manage/clients/items?showToReview=true';
        navItm.badgeNumber = this.alertNumbers.toReviewBrandProducts;
      }
      else if(navItm.url == '/inventory/manual-shipments') {
        navItm.badgeUrl = '/inventory/manual-shipments?orderStatus=Draft';
        navItm.badgeNumber = this.alertNumbers.toReviewSmallParcelShipments;
      }
      else if(navItm.url == '/inventory/bulkShipments') {
        navItm.badgeUrl = '/inventory/bulkShipments?orderStatus=Draft';
        navItm.badgeNumber = this.alertNumbers.toReviewBulkShipments;
      }
      else if(navItm.url == '/storefronts/products') {
        navItm.badgeUrl = '/storefronts/products?showOnlyRequiresMapping=true';
        navItm.badgeNumber = this.alertNumbers.toReviewStorefrontProducts;
      }
      else if(navItm.url == '/orders?orderStatus=on_hold&onHoldReason=Not Enough Inventory') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.noInventory;
        navItm.badgeColor = 'warning';
      }
      else if(navItm.url == '/orders?orderStatus=on_hold&onHoldReason=Address Validation') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.addressValidation;
      }
      else if(navItm.url == '/orders/split-recs') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.splitRecsNum;
        navItm.badgeColor = 'warning';
      }
      else if(navItm.url == '/orders/unhold-recs') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.recUnholdNum;
      }
      else if(navItm.url == '/orders?orderStatus=on_hold&onHoldReason=Warehouse Error') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.warehouseErrors;
      }
      else if(navItm.url == '/orders?orderStatus=on_hold&onHoldReason=SKU Not Configured') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.missingStorefrontProductConfig;
      }
      else if(navItm.url == '/orders?orderStatus=on_hold&onHoldReason=ShipCode Not Configured') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.shipCodeMappings;
      }
      else if(navItm.url == '/orders?orderStatus=on_hold&onHoldReason=Review Needed') {
        navItm.badgeNumber = this.alertNumbers.toReviewOnOrders.reviewNeededOther;
        navItm.badgeColor = 'warning';
      }
      else {
        navItm.badgeNumber = 0;
      }
      if(navItm.children && navItm.children.length) {
        let totalChilrenBadgeNumber = 0;
        navItm.children.forEach(child => {
          child.isOpen = false;
          this.setNavItemDefaults(child);
          if(child.badgeColor != 'warning')
          totalChilrenBadgeNumber += child.badgeNumber;
        });
        if(navItm.badgeNumber == 0) {
          navItm.badgeNumber = totalChilrenBadgeNumber;
        }
      }
    },
    checkIfCanSeeNavItem(itm) {
      if(itm.children && itm.children.length) {
        itm.children.forEach((child, keya) => {
          if(child != null && this.checkIfCanSeeNavItem(child) === false) {
            console.log('cannot access nav subitem: ', child.title)
            delete itm.children[keya];
          }
        });
        itm.children = itm.children.filter(a => a != null);
        if(itm.children.length == 0) {
          itm = null;
        }
      }
      if(itm != null && itm.permissionRequired == null) {
        return itm;
      } else if(itm != null){
        if(this.$store.getters['account/hasUserPermission'](itm.permissionRequired)) {
          return itm;
        }
      }
      return false;
    },
    checkIfShouldCollapse() {
        if (document.getElementsByTagName("body")[0].offsetWidth < 1650) {
          $('body').addClass('sidebar-minimized');
          this.togglePs(false);
        } else {
          $('body').removeClass('sidebar-minimized');
          this.togglePs(true);
        }
    },
    togglePs(toggle) {
      const sidebar = document.querySelector('.sidebar-nav section');
      if (sidebar) {
        // sidebar.classList.toggle('ps', toggle);
        // sidebar.classList.toggle('ps-container', toggle);
        // sidebar.classList.toggle('ps--active-y', toggle);
        if (toggle) {
          sidebar.classList.add('ps', 'ps-container', 'ps--active-y');
        } else {
          sidebar.classList.remove('ps', 'ps-container', 'ps--active-y');
        }
      }
    }
  }
};
</script>
